import request from '@/utils/request';
// import { getToken } from "@/utils/auth"; // get token
import configR from '@/configs.js';
const API = configR.envConfigs.PORTAL_API;

// 获取用户按钮权限
export function getSetting() {
  return request({
    url: `${API}/v1/config/system/getSystemConf`,
    method: 'get',
  });
}

